<template>
    <div class="elevation-3 ma-3 pa-1">
        <div>
            <v-row>
            <v-col cols="3" sm="4">
            <v-card width="500px" class="">
                <p class="font-weight-light mb-0 text-subtitle-1 pt-1 pl-1">Remarks :
                     {{ itemsGetter.comments }} </p>
              </v-card>
            </v-col>
            <v-col cols="3" sm="4">
                <div class="d-flex mb-1 mt-1">
                    <v-btn class="input-text-size mr-2" text color="blue darken-1"
                    @click="postSelectedRecords">
                      Post Selected Record
                    </v-btn>
                    <v-btn class="input-text-size mr-2" text color="blue darken-1"
                     @click="createReversingEntry">Create Reversing Entries</v-btn>
                    <v-btn class="input-text-size mr-2" text color="blue darken-1"
                     @click="workFile">
                     Create Work File
                    </v-btn>
                </div>
            </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import {
  mapGetters,
} from 'vuex';
import '../../../assets/style.css';

export default {
  name: 'TaxRollAdjustmentsFooter',
  components: {
  },
  props: {
    createWorkFile: {
      type: Function,
      required: true,
    },
    postSelectedRecords: {
      type: Function,
    },
    createReversingEntry: {
      type: Function,
    },
    adjustmentReport: Function,
  },
  data() {
    return {
      baseCrudKey: 'taxRollAdjustmentsList',
    };
  },
  created() {
  },
  destroyed() {
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'isVisible',
      'selectedTab',
    ]),
    itemsGetter() {
      const itemData = this.item(this.baseCrudKey);
      return itemData;
    },
  },
  methods: {
    workFile() {
      this.createWorkFile();
    },
  },
};
</script>
